import React from 'react';
import AppSidebar from '../../../components/AppSidebar';
import AppHeader from '../../../components/AppHeader';
import PageHeader from '../../../components/PageHeader';
import { proposalStatusOptions, currencyOptions } from '../../../../src/utils/OptionUtils';
import DocumentForm from '../../../components/DocumentForm';


const EditProposal = () => {
  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <PageHeader title="WFZ/24-25/PR/000018" className="btn btn-sm btn-primary" link_to="/proposals" button_label="Back" />

          <div className="card mt-4 shadow-sm">
            <div className="card-body">
              <form>
                <div className="row">
                  {/* Left Column */}
                  <div className="col-12 col-xl-6">
                    <div className="mb-3">
                      <label htmlFor="subject" className="form-label">Subject</label>
                      <input type="text" className="form-control" name="subject" id="subject" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="related" className="form-label">Related</label>
                      <input type="text" className="form-control" name="related" id="related" />
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="date" className="form-label">Date</label>
                          <input type="date" className="form-control" name="date" id="date" />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="open_till" className="form-label">Open Till</label>
                          <input type="date" className="form-control" name="open_till" id="open_till" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="currency" className="form-label">Currency</label>
                          <select className="form-control form-select" name="status" id="status" defaultValue={'inr'}>
                            <option value="">Select Currency</option>
                            {currencyOptions?.map((option, index) => (
                              <option key={index} value={option.value}>{option.label}</option>
                            ))}
                          </select>                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="discount_type" className="form-label">Discount Type</label>
                          <input type="text" className="form-control" name="discount_type" id="discount_type" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="col-12 col-xl-6">
                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="status" className="form-label">Status</label>
                          <select className="form-control form-select" name="status" id="status">
                            <option value="">Select Status</option>
                            {proposalStatusOptions?.map((option, index) => (
                              <option key={index} value={option.value}>{option.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="assign" className="form-label">Assign</label>
                          <input type="text" className="form-control" name="assign" id="assign" />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="to" className="form-label">To</label>
                      <input type="text" className="form-control" name="to" id="to" />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="address" className="form-label">Address</label>
                      <textarea className="form-control" name="address" id="address" rows="3"></textarea>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="city" className="form-label">City</label>
                          <input type="text" className="form-control" name="city" id="city" />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state" className="form-label">State</label>
                          <input type="text" className="form-control" name="state" id="state" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country" className="form-label">Country</label>
                          <select className="form-control" name="country" id="country">
                            <option value="">Select Country</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="zipcode" className="form-label">Zipcode</label>
                          <input type="text" className="form-control" name="zipcode" id="zipcode" maxLength={6} />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="email" className="form-label">Email</label>
                          <input type="email" className="form-control" name="email" id="email" />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="phone" className="form-label">Phone</label>
                          <input type="text" className="form-control" name="phone" id="phone" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

             <div className="row">
              <DocumentForm />
            </div>
                <div className="text-end mt-3">
                  <button type="submit" className="btn btn-light me-2">Save & Send</button>
                  <button type="submit" className="btn btn-primary">Save</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProposal;
